<template>
  <BaseLinksWidget heading="Sustainability" :links="links">
    <!-- This is a badly styled slot that demonstrates how to use the `description` slot.
      <template #description="{ link }">
        <div class="text-sm text-yellow-700" v-if="link.description">Badly styled slot: {{ link.description }}</div>
      </template> -->
  </BaseLinksWidget>
</template>

<script setup lang="ts">
import { useInternalLandingStore } from "@/components/internalLandingStore";
import { BaseLinksWidget } from "@modernary/mui/components/widgetGrid";
import { computed } from "vue";

const internalLandingStore = useInternalLandingStore();

const links = computed(() => internalLandingStore.sustainabilityLinks);
</script>
